import { useEffect, useRef, useState } from 'react';

export const useTourPopoverFade = (currentStopId: string | undefined) => {
  const [open, setOpen] = useState(true);
  const previousStopId = useRef<string | null>(null);

  useEffect(() => {
    if (currentStopId && currentStopId !== previousStopId.current) {
      previousStopId.current = currentStopId;

      if (open) {
        setOpen(false);
        setTimeout(() => {
          setOpen(true);
        }, 200);
      }
    }
  }, [currentStopId, open]);

  return { open };
};
